/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Late_Heroic_Parakeet_YellInputs */

const fr_late_heroic_parakeet_yell = /** @type {(inputs: Late_Heroic_Parakeet_YellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine suivante`)
};

/**

* @param {Late_Heroic_Parakeet_YellInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const late_heroic_parakeet_yell = /** @type {((inputs?: Late_Heroic_Parakeet_YellInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Late_Heroic_Parakeet_YellInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_late_heroic_parakeet_yell(inputs)
});